import React, { useState } from "react";
import api from "@/lib/api";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Enter your email");
    try {
      setLoading(true);
      await api.post("/users/forgot-password", { email: email.trim() });
      toast.success("If that email exists, a reset link was sent.");
    } catch {
      toast.error("Could not send reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-blue-50">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md p-6 bg-white shadow-lg rounded-2xl"
      >
        <h1 className="mb-2 text-2xl font-bold text-center text-blue-900">
          Forgot Password
        </h1>
        <p className="mb-6 text-sm text-center text-gray-600">
          Enter your account email and we'll send you a reset link.
        </p>

        <label className="block mb-1 text-sm font-semibold text-blue-900">
          Email
        </label>
        <input
          type="email"
          className="w-full px-4 py-2 mb-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full py-2 font-semibold text-white transition bg-blue-900 rounded hover:bg-blue-800 disabled:opacity-70"
        >
          {loading ? "Sending..." : "Send reset link"}
        </button>

        <div className="flex justify-between mt-6 text-sm">
          <Link className="text-blue-700 hover:underline" to="/login">
            Back to login
          </Link>
          <Link className="text-blue-700 hover:underline" to="/register">
            Create account
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPasswordPage;
